
import { useGetTranslations } from '@/composables/useGetTranslations';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import { useCart } from '@/composables/useCart';

export default {
  name: 'RemovedGiftNotice',
  components: {
    AzIcon,
  },
  props: {
    rejectedGifts: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const { translate } = useGetTranslations();
    const { setGiftRejection } = useCart();

    const cancelRemoveGift = (product) => {
      setGiftRejection(product, false);
    };

    return {
      translate,
      cancelRemoveGift,
    };
  },
};
